/* ============================================================================
   Motor JS restaurado — Sale Accesorios (tema base Shrine/Dawn)
   Reconstruido a partir de Dawn de Shopify (licencia MIT) y adaptado al
   markup real de este tema. Reemplaza el shrine.null.js vacío.

   Restaura:
   - Utilidades globales: debounce, throttle, trapFocus, pauseAllMedia, etc.
     (las usan secondary.js, media-gallery.js, facets.js, cart-notification.js)
   - <variant-selects>  : cambio de variante → precio, imagen, disponibilidad
   - <product-form>     : agregar al carrito vía AJAX (habilita input name=id)
   - <quantity-input>   : botones +/- de cantidad
   - <cart-items> / <cart-drawer-items> / <cart-drawer> / <cart-remove-button>
   - <predictive-search>: sugerencias de búsqueda
   - <sticky-atc>       : barra fija de compra (Shrine)
   - <dynamic-dates>    : fechas estimadas de envío (Shrine)
   - <internal-video>   : controles de video (Shrine)
   ============================================================================ */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /* Utilidades globales (Dawn, MIT)                                     */
  /* ------------------------------------------------------------------ */

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }

  var trapFocusHandlers = {};

  function trapFocus(container, elementToFocus) {
    elementToFocus = elementToFocus || container;
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = function (event) {
      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    if (elementToFocus) elementToFocus.focus();

    if (
      elementToFocus &&
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].indexOf(elementToFocus.type) !== -1 &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  }

  function removeTrapFocus(elementToFocus) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
    if (elementToFocus) elementToFocus.focus();
  }

  function onKeyUpEscape(event) {
    if (!event.code || event.code.toUpperCase() !== 'ESCAPE') return;
    var openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
    var summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    if (summaryElement) {
      summaryElement.setAttribute('aria-expanded', false);
      summaryElement.focus();
    }
  }

  function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach(function (video) {
      try {
        video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      } catch (e) {}
    });
    document.querySelectorAll('.js-vimeo').forEach(function (video) {
      try {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      } catch (e) {}
    });
    document.querySelectorAll('video').forEach(function (video) {
      video.pause();
    });
    document.querySelectorAll('product-model').forEach(function (model) {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var self = this;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(self, args);
      }, wait);
    };
  }

  function throttle(fn, delay) {
    var lastCall = 0;
    return function () {
      var now = Date.now();
      if (now - lastCall < (delay || 0)) return;
      lastCall = now;
      return fn.apply(this, arguments);
    };
  }

  function fetchConfig(type) {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/' + (type || 'json'),
      },
    };
  }

  /* pub/sub (Dawn, MIT) */
  var PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    variantChange: 'variant-change',
    cartError: 'cart-error',
  };
  var subscribers = {};

  function subscribe(eventName, callback) {
    if (subscribers[eventName] === undefined) subscribers[eventName] = [];
    subscribers[eventName] = subscribers[eventName].concat(callback);
    return function unsubscribe() {
      subscribers[eventName] = subscribers[eventName].filter(function (cb) {
        return cb !== callback;
      });
    };
  }

  function publish(eventName, data) {
    if (!subscribers[eventName]) return;
    subscribers[eventName].forEach(function (callback) {
      try {
        callback(data);
      } catch (e) {
        console.error(e);
      }
    });
  }

  /* Helper: extraer contenido de una sección renderizada */
  function getSectionInnerHTML(html, selectors) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var list = Array.isArray(selectors) ? selectors : [selectors];
    for (var i = 0; i < list.length; i++) {
      var el = doc.querySelector(list[i]);
      if (el) return el.innerHTML;
    }
    return null;
  }

  /* Exponer globales que esperan los demás scripts del tema */
  window.getFocusableElements = window.getFocusableElements || getFocusableElements;
  window.trapFocus = window.trapFocus || trapFocus;
  window.removeTrapFocus = window.removeTrapFocus || removeTrapFocus;
  window.onKeyUpEscape = window.onKeyUpEscape || onKeyUpEscape;
  window.pauseAllMedia = window.pauseAllMedia || pauseAllMedia;
  window.debounce = window.debounce || debounce;
  window.throttle = window.throttle || throttle;
  window.fetchConfig = window.fetchConfig || fetchConfig;
  window.subscribe = window.subscribe || subscribe;
  window.publish = window.publish || publish;
  window.PUB_SUB_EVENTS = window.PUB_SUB_EVENTS || PUB_SUB_EVENTS;
  window.ON_CHANGE_DEBOUNCE_TIMER = window.ON_CHANGE_DEBOUNCE_TIMER || 300;

  /* ------------------------------------------------------------------ */
  /* <quantity-input> — botones +/- de cantidad (Dawn, MIT)              */
  /* ------------------------------------------------------------------ */
  if (!customElements.get('quantity-input')) {
    customElements.define(
      'quantity-input',
      class QuantityInput extends HTMLElement {
        constructor() {
          super();
          this.input = this.querySelector('input');
          if (!this.input) return;
          this.changeEvent = new Event('change', { bubbles: true });
          var self = this;
          this.querySelectorAll('button').forEach(function (button) {
            button.addEventListener('click', function (event) {
              event.preventDefault();
              var previousValue = self.input.value;
              if (button.name === 'plus') {
                self.input.stepUp();
              } else if (button.name === 'minus') {
                self.input.stepDown();
              }
              if (previousValue !== self.input.value) {
                self.input.dispatchEvent(self.changeEvent);
              }
            });
          });
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <variant-selects> — selector de variantes (Dawn, MIT; adaptado)     */
  /* ------------------------------------------------------------------ */
  if (!customElements.get('variant-selects')) {
    customElements.define(
      'variant-selects',
      class VariantSelects extends HTMLElement {
        constructor() {
          super();
          this.addEventListener('change', this.onVariantChange.bind(this));
        }

        onVariantChange() {
          this.updateOptions();
          this.updateMasterId();
          this.toggleAddButton(true, '');
          this.removeErrorMessage();

          if (!this.currentVariant) {
            this.toggleAddButton(true, window.variantStrings ? window.variantStrings.unavailable : '');
            this.setUnavailable();
          } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.updateVariantStatuses();
            this.renderProductInfo();
            this.updatePickupAvailability();
          }

          publish(PUB_SUB_EVENTS.variantChange, {
            data: { sectionId: this.dataset.section, variant: this.currentVariant },
          });
          this.dispatchEvent(
            new CustomEvent('variant:change', {
              bubbles: true,
              detail: { variant: this.currentVariant, sectionId: this.dataset.section },
            })
          );
        }

        updateOptions() {
          var options = [];
          this.querySelectorAll('.product-form__input').forEach(function (group) {
            var select = group.querySelector('select');
            if (select) {
              options.push(select.value);
              return;
            }
            var checked = group.querySelector('input[type="radio"]:checked');
            if (checked) options.push(checked.value);
          });
          this.options = options;
        }

        updateMasterId() {
          var options = this.options;
          this.currentVariant = this.getVariantData().find(function (variant) {
            return !variant.options
              .map(function (option, index) {
                return options[index] === option;
              })
              .includes(false);
          });
        }

        updateMedia() {
          if (!this.currentVariant || !this.currentVariant.featured_media) return;
          var section = this.dataset.section;
          var mediaId = section + '-' + this.currentVariant.featured_media.id;
          document.querySelectorAll('[id^="MediaGallery-' + section + '"]').forEach(function (gallery) {
            if (typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(mediaId, true);
          });
        }

        updateURL() {
          if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
          window.history.replaceState({}, '', this.dataset.url + '?variant=' + this.currentVariant.id);
        }

        updateVariantInput() {
          var self = this;
          var selector =
            '#product-form-' + this.dataset.section + ', #product-form-installment-' + this.dataset.section;
          document.querySelectorAll(selector).forEach(function (productForm) {
            var input = productForm.querySelector('input[name="id"]');
            if (!input) return;
            input.value = self.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }

        updateVariantStatuses() {
          var variantData = this.getVariantData();
          var selectedOptions = this.options;
          this.querySelectorAll('.product-form__input').forEach(function (group, groupIndex) {
            group.querySelectorAll('input[type="radio"]').forEach(function (input) {
              var testOptions = selectedOptions.slice(0, groupIndex);
              testOptions.push(input.value);
              var available = variantData.some(function (variant) {
                for (var i = 0; i <= groupIndex; i++) {
                  if (variant.options[i] !== testOptions[i]) return false;
                }
                return variant.available;
              });
              input.classList.toggle('disabled', !available);
            });
          });
        }

        updatePickupAvailability() {
          var pickup = document.querySelector('pickup-availability');
          if (!pickup) return;
          if (this.currentVariant && this.currentVariant.available) {
            if (typeof pickup.fetchAvailability === 'function') pickup.fetchAvailability(this.currentVariant.id);
          } else {
            pickup.removeAttribute('available');
            pickup.innerHTML = '';
          }
        }

        removeErrorMessage() {
          var section = this.closest('section') || document;
          var productForm = section.querySelector('product-form');
          if (productForm && typeof productForm.handleErrorMessage === 'function') {
            productForm.handleErrorMessage();
          }
        }

        renderProductInfo() {
          var self = this;
          var section = this.dataset.section;
          var requestedVariantId = this.currentVariant.id;
          fetch(this.dataset.url + '?variant=' + requestedVariantId + '&section_id=' + section)
            .then(function (response) {
              return response.text();
            })
            .then(function (responseText) {
              if (!self.currentVariant || self.currentVariant.id !== requestedVariantId) return;
              var doc = new DOMParser().parseFromString(responseText, 'text/html');

              /* Swap de bloques identificados por id */
              [
                'price-' + section,
                'main-atc-price-' + section,
                'sticky-atc-separate-price-' + section,
                'sticky-atc-image-' + section,
                'Sku-' + section,
                'Inventory-' + section,
                'price-per-item-' + section,
                'Quantity-Rules-' + section,
              ].forEach(function (id) {
                var src = doc.getElementById(id);
                var dst = document.getElementById(id);
                if (src && dst) {
                  dst.innerHTML = src.innerHTML;
                  dst.className = src.className;
                }
              });

              var price = document.getElementById('price-' + section);
              if (price) price.classList.remove('visually-hidden');

              /* Estado y texto del botón principal + botones sticky */
              var srcButton = doc.getElementById('ProductSubmitButton-' + section);
              var dstButtons = [];
              var mainBtn = document.getElementById('ProductSubmitButton-' + section);
              if (mainBtn) dstButtons.push(mainBtn);
              var stickyWrap = document.getElementById('sticky-atc-' + section);
              if (stickyWrap) {
                stickyWrap.querySelectorAll('button[name="add"]').forEach(function (b) {
                  dstButtons.push(b);
                });
              }
              if (srcButton) {
                var srcLabel = srcButton.querySelector('.main-atc__label');
                dstButtons.forEach(function (btn) {
                  btn.toggleAttribute('disabled', srcButton.hasAttribute('disabled'));
                  var dstLabel = btn.querySelector('.main-atc__label');
                  if (srcLabel && dstLabel) dstLabel.innerHTML = srcLabel.innerHTML;
                });
              }
            })
            .catch(function (e) {
              console.error(e);
            });
        }

        toggleAddButton(disable, text) {
          var productForm = document.getElementById('product-form-' + this.dataset.section);
          if (!productForm) return;
          var addButton = productForm.querySelector('[name="add"]');
          if (!addButton) return;
          var addButtonText = addButton.querySelector('.main-atc__label') || addButton.querySelector('span');
          if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text && addButtonText) addButtonText.textContent = text;
          } else {
            addButton.removeAttribute('disabled');
          }
        }

        setUnavailable() {
          var section = this.dataset.section;
          var price = document.getElementById('price-' + section);
          if (price) price.classList.add('visually-hidden');
        }

        getVariantData() {
          if (!this.variantData) {
            var script = this.querySelector('script[type="application/json"]');
            this.variantData = script ? JSON.parse(script.textContent) : [];
          }
          return this.variantData;
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <product-form> — agregar al carrito vía AJAX (Dawn, MIT; adaptado)  */
  /* ------------------------------------------------------------------ */
  if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();
          this.form = this.querySelector('form');
          if (!this.form) return;
          var idInput = this.variantIdInput;
          if (idInput) idInput.disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');
          if (this.submitButton && document.querySelector('cart-drawer')) {
            this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }
        }

        get variantIdInput() {
          return this.form ? this.form.querySelector('input[name="id"]') : null;
        }

        /* Shrine API: lo usa el script inline de theme.liquid y la sticky bar */
        handleSubmit(evt) {
          this.onSubmitHandler(evt);
        }

        onSubmitHandler(evt) {
          if (evt) evt.preventDefault();
          if (!this.form || !this.submitButton) return;
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
          if (this.submitButton.hasAttribute('disabled') && this.submitButton.dataset.unavailable === 'true') return;
          if (!this.form.reportValidity()) return;

          this.handleErrorMessage();
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          var spinner = this.submitButton.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.remove('hidden');

          var self = this;
          var idInput = this.variantIdInput;
          var skipCart = !!(idInput && idInput.dataset.skipCart === 'true');

          var config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          var formData = new FormData(this.form);
          if (this.cart && !skipCart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map(function (s) {
                return s.id;
              })
            );
            formData.append('sections_url', window.location.pathname);
            if (typeof this.cart.setActiveElement === 'function') {
              this.cart.setActiveElement(document.activeElement);
            }
          }
          config.body = formData;

          fetch((window.routes && window.routes.cart_add_url) || '/cart/add', config)
            .then(function (response) {
              return response.json();
            })
            .then(function (response) {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                self.handleErrorMessage(response.description || response.message);
                return;
              }
              if (skipCart) {
                window.location = '/checkout';
                return;
              }
              if (!self.cart) {
                window.location = (window.routes && window.routes.cart_url) || '/cart';
                return;
              }
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
              self.error = false;
              self.cart.renderContents(response);
            })
            .catch(function (e) {
              console.error(e);
            })
            .finally(function () {
              self.submitButton.classList.remove('loading');
              if (self.cart && self.cart.classList.contains('is-empty')) {
                self.cart.classList.remove('is-empty');
              }
              if (!self.error) self.submitButton.removeAttribute('aria-disabled');
              var spinner2 = self.submitButton.querySelector('.loading-overlay__spinner');
              if (spinner2) spinner2.classList.add('hidden');
            });
        }

        handleErrorMessage(errorMessage) {
          this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) {
            if (errorMessage) alert(errorMessage);
            return;
          }
          this.errorMessage =
            this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
          if (this.errorMessage) this.errorMessage.textContent = errorMessage || '';
          if (errorMessage) this.error = true;
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <cart-remove-button> (Dawn, MIT)                                    */
  /* ------------------------------------------------------------------ */
  if (!customElements.get('cart-remove-button')) {
    customElements.define(
      'cart-remove-button',
      class CartRemoveButton extends HTMLElement {
        constructor() {
          super();
          var self = this;
          this.addEventListener('click', function (event) {
            event.preventDefault();
            var cartItems = self.closest('cart-items') || self.closest('cart-drawer-items');
            if (cartItems && typeof cartItems.updateQuantity === 'function') {
              cartItems.updateQuantity(self.dataset.index, 0);
            }
          });
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <cart-items> — página del carrito (Dawn, MIT; adaptado)             */
  /* ------------------------------------------------------------------ */
  class CartItems extends HTMLElement {
    constructor() {
      super();
      this.lineItemStatusElement =
        document.getElementById('shopping-cart-line-item-status') ||
        document.getElementById('CartDrawer-LineItemStatus');
      this.addEventListener('change', debounce(this.onChange.bind(this), window.ON_CHANGE_DEBOUNCE_TIMER || 300));
    }

    onChange(event) {
      var input = event.target;
      if (!input || input.name !== 'updates[]') return;
      var index = input.dataset.index || (input.id.match(/(\d+)$/) || [])[1];
      if (!index) return;
      var activeName = document.activeElement ? document.activeElement.getAttribute('name') : null;
      this.updateQuantity(index, input.value, activeName, input.dataset.quantityVariantId);
    }

    getSectionsToRender() {
      var sections = [];
      var mainSection = this.closest('.shopify-section');
      if (mainSection) {
        sections.push({
          id: mainSection.id.replace('shopify-section-', ''),
          targetId: mainSection.id,
          selectors: ['#' + mainSection.id, '.shopify-section'],
        });
      }
      var footerWrapper = document.querySelector('.cart__footer-wrapper');
      if (footerWrapper && footerWrapper.id) {
        sections.push({
          id: footerWrapper.id.replace('shopify-section-', ''),
          targetId: footerWrapper.id,
          selectors: ['#' + footerWrapper.id, '.shopify-section'],
        });
      }
      sections.push({
        id: 'cart-icon-bubble',
        targetId: 'cart-icon-bubble',
        selectors: ['.shopify-section'],
      });
      return sections;
    }

    updateQuantity(line, quantity, name, variantId) {
      this.enableLoading(line);
      var self = this;
      var sections = this.getSectionsToRender();
      var body = JSON.stringify({
        line: line,
        quantity: quantity,
        sections: sections.map(function (s) {
          return s.id;
        }),
        sections_url: window.location.pathname,
      });
      var config = fetchConfig();
      config.body = body;

      fetch((window.routes && window.routes.cart_change_url) || '/cart/change', config)
        .then(function (response) {
          return response.text();
        })
        .then(function (state) {
          var parsedState = JSON.parse(state);

          if (parsedState.errors) {
            self.restoreInputValue(line);
            self.showLineItemError(line, parsedState.errors);
            return;
          }

          var isEmpty = parsedState.item_count === 0;
          self.classList.toggle('is-empty', isEmpty);
          var drawer = document.querySelector('cart-drawer');
          if (drawer) drawer.classList.toggle('is-empty', isEmpty);

          sections.forEach(function (section) {
            var html = parsedState.sections && parsedState.sections[section.id];
            var target = document.getElementById(section.targetId);
            if (!html || !target) return;
            var inner = getSectionInnerHTML(html, section.selectors);
            if (inner !== null) target.innerHTML = inner;
          });

          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        })
        .catch(function (e) {
          console.error(e);
          if (window.cartStrings && self.lineItemStatusElement) {
            var errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
            if (errors) errors.textContent = window.cartStrings.error;
          }
        })
        .finally(function () {
          self.disableLoading(line);
        });
    }

    restoreInputValue(line) {
      var input =
        document.getElementById('Quantity-' + line) || document.getElementById('Drawer-quantity-' + line);
      if (input && input.dataset.cartQuantity !== undefined) input.value = input.dataset.cartQuantity;
    }

    showLineItemError(line, message) {
      var lineError =
        document.getElementById('Line-item-error-' + line) ||
        document.getElementById('CartDrawer-LineItemError-' + line);
      if (lineError) {
        var target = lineError.querySelector('.cart-item__error-text') || lineError;
        target.textContent = message;
        lineError.removeAttribute('hidden');
      } else {
        alert(message);
      }
    }

    enableLoading(line) {
      this.classList.add('cart__items--disabled');
      var item =
        document.getElementById('CartItem-' + line) || document.getElementById('CartDrawer-Item-' + line);
      if (item) {
        item.querySelectorAll('.loading-overlay').forEach(function (overlay) {
          overlay.classList.remove('hidden');
        });
      }
      if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading(line) {
      this.classList.remove('cart__items--disabled');
      var item =
        document.getElementById('CartItem-' + line) || document.getElementById('CartDrawer-Item-' + line);
      if (item) {
        item.querySelectorAll('.loading-overlay').forEach(function (overlay) {
          overlay.classList.add('hidden');
        });
      }
      if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);
    }
  }

  if (!customElements.get('cart-items')) {
    customElements.define('cart-items', CartItems);
  }

  /* ------------------------------------------------------------------ */
  /* <cart-drawer> + <cart-drawer-items> (Dawn, MIT; adaptado)           */
  /* ------------------------------------------------------------------ */
  if (!customElements.get('cart-drawer')) {
    customElements.define(
      'cart-drawer',
      class CartDrawer extends HTMLElement {
        constructor() {
          super();
          var self = this;
          this.addEventListener('keyup', function (event) {
            if (event.code && event.code.toUpperCase() === 'ESCAPE') self.close();
          });
          var overlay = this.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', this.close.bind(this));
          this.setHeaderCartIconAccessibility();
        }

        setHeaderCartIconAccessibility() {
          var self = this;
          var cartLink = document.querySelector('#cart-icon-bubble');
          if (!cartLink) return;
          cartLink.setAttribute('role', 'button');
          cartLink.setAttribute('aria-haspopup', 'dialog');
          cartLink.addEventListener('click', function (event) {
            event.preventDefault();
            self.open(cartLink);
          });
          cartLink.addEventListener('keydown', function (event) {
            if (event.code && event.code.toUpperCase() === 'SPACE') {
              event.preventDefault();
              self.open(cartLink);
            }
          });
        }

        open(triggeredBy) {
          if (triggeredBy) this.setActiveElement(triggeredBy);
          var self = this;
          /* doble rAF para que la transición CSS se aplique al agregar .active */
          this.classList.add('animate');
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              self.classList.add('active');
            });
          });
          this.addEventListener(
            'transitionend',
            function () {
              var containerToTrapFocusOn = self.classList.contains('is-empty')
                ? self.querySelector('.drawer__inner-empty') || self
                : document.getElementById('CartDrawer') || self;
              var focusElement = self.querySelector('.drawer__inner') || self.querySelector('.drawer__close');
              trapFocus(containerToTrapFocusOn, focusElement);
            },
            { once: true }
          );
          document.body.classList.add('overflow-hidden');
        }

        close() {
          this.classList.remove('active');
          removeTrapFocus(this.activeElement);
          document.body.classList.remove('overflow-hidden');
        }

        renderContents(parsedState) {
          var self = this;
          this.productId = parsedState.id;
          this.getSectionsToRender().forEach(function (section) {
            var target = document.getElementById(section.targetId);
            var html = parsedState.sections && parsedState.sections[section.id];
            if (!target || !html) return;
            var inner = getSectionInnerHTML(html, section.selectors);
            if (inner !== null) target.innerHTML = inner;
          });
          this.classList.remove('is-empty');
          setTimeout(function () {
            var overlay = self.querySelector('#CartDrawer-Overlay');
            if (overlay) overlay.addEventListener('click', self.close.bind(self));
            self.open();
          });
        }

        getSectionsToRender() {
          return [
            { id: 'cart-drawer', targetId: 'CartDrawer', selectors: ['#CartDrawer', '.shopify-section'] },
            { id: 'cart-icon-bubble', targetId: 'cart-icon-bubble', selectors: ['.shopify-section'] },
          ];
        }

        setActiveElement(element) {
          this.activeElement = element;
        }
      }
    );
  }

  if (!customElements.get('cart-drawer-items')) {
    customElements.define(
      'cart-drawer-items',
      class CartDrawerItems extends CartItems {
        getSectionsToRender() {
          return [
            { id: 'cart-drawer', targetId: 'CartDrawer', selectors: ['#CartDrawer', '.shopify-section'] },
            { id: 'cart-icon-bubble', targetId: 'cart-icon-bubble', selectors: ['.shopify-section'] },
          ];
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <predictive-search> — sugerencias de búsqueda (Dawn, MIT)           */
  /* ------------------------------------------------------------------ */
  if (!customElements.get('predictive-search')) {
    customElements.define(
      'predictive-search',
      class PredictiveSearch extends HTMLElement {
        constructor() {
          super();
          this.input = this.querySelector('input[type="search"]');
          this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
          this.isOpen = false;
          if (!this.input || !this.predictiveSearchResults) return;

          var form = this.querySelector('form.search');
          if (form) {
            form.addEventListener('submit', this.onFormSubmit.bind(this));
          }
          this.input.addEventListener('input', debounce(this.onChange.bind(this), 300));
          this.input.addEventListener('focus', this.onFocus.bind(this));
          this.addEventListener('focusout', this.onFocusOut.bind(this));
          this.addEventListener('keyup', this.onKeyup.bind(this));
        }

        getQuery() {
          return this.input.value.trim();
        }

        onChange() {
          var searchTerm = this.getQuery();
          if (!searchTerm.length) {
            this.close(true);
            return;
          }
          this.getSearchResults(searchTerm);
        }

        onFormSubmit(event) {
          if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
            event.preventDefault();
          }
        }

        onFocus() {
          var searchTerm = this.getQuery();
          if (!searchTerm.length) return;
          if (this.getAttribute('results') === 'true') {
            this.open();
          } else {
            this.getSearchResults(searchTerm);
          }
        }

        onFocusOut() {
          var self = this;
          setTimeout(function () {
            if (!self.contains(document.activeElement)) self.close();
          });
        }

        onKeyup(event) {
          if (!this.getQuery().length) this.close(true);
          if (event.code && event.code.toUpperCase() === 'ESCAPE') this.close(true);
        }

        getSearchResults(searchTerm) {
          var self = this;
          var queryKey = searchTerm.replace(' ', '-').toLowerCase();
          this.setLiveRegionLoadingState();

          this.cachedResults = this.cachedResults || {};
          if (this.cachedResults[queryKey]) {
            this.renderSearchResults(this.cachedResults[queryKey]);
            return;
          }

          var url =
            ((window.routes && window.routes.predictive_search_url) || '/search/suggest') +
            '?q=' +
            encodeURIComponent(searchTerm) +
            '&section_id=predictive-search';

          fetch(url)
            .then(function (response) {
              if (!response.ok) {
                self.close();
                throw new Error(response.status);
              }
              return response.text();
            })
            .then(function (text) {
              var doc = new DOMParser().parseFromString(text, 'text/html');
              var container = doc.querySelector('#shopify-section-predictive-search');
              var resultsMarkup = container ? container.innerHTML : '';
              self.cachedResults[queryKey] = resultsMarkup;
              self.renderSearchResults(resultsMarkup);
            })
            .catch(function (error) {
              self.close();
            });
        }

        setLiveRegionLoadingState() {
          this.setAttribute('loading', true);
        }

        renderSearchResults(resultsMarkup) {
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.setAttribute('results', true);
          this.removeAttribute('loading');
          this.open();
        }

        open() {
          this.setAttribute('open', true);
          this.input.setAttribute('aria-expanded', true);
          this.isOpen = true;
        }

        close(clearSearchTerm) {
          if (clearSearchTerm) {
            this.input.value = '';
            this.removeAttribute('results');
          }
          var selected = this.querySelector('[aria-selected="true"]');
          if (selected) selected.setAttribute('aria-selected', false);
          this.input.setAttribute('aria-activedescendant', '');
          this.removeAttribute('loading');
          this.removeAttribute('open');
          this.input.setAttribute('aria-expanded', false);
          if (this.predictiveSearchResults) this.predictiveSearchResults.removeAttribute('style');
          this.isOpen = false;
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <sticky-atc> — barra fija de compra (equivalente Shrine)            */
  /* ------------------------------------------------------------------ */
  if (!customElements.get('sticky-atc')) {
    customElements.define(
      'sticky-atc',
      class StickyAtc extends HTMLElement {
        constructor() {
          super();
          var self = this;
          this.section = this.dataset.section;

          /* Botón de la barra → envía el formulario principal del producto */
          this.querySelectorAll('button[name="add"], button[type="submit"]').forEach(function (btn) {
            btn.addEventListener('click', function (event) {
              event.preventDefault();
              var productForm =
                document.getElementById('ProductForm-' + self.section) ||
                document.querySelector('.main-product-form');
              if (productForm && typeof productForm.handleSubmit === 'function') {
                productForm.handleSubmit(event);
              }
            });
          });

          /* Select de variante dentro de la barra (si existe) → refleja al picker principal */
          this.querySelectorAll('select').forEach(function (select) {
            select.addEventListener('change', function () {
              var mainPicker = document.getElementById('variant-selects-' + self.section);
              if (!mainPicker) return;
              var mainSelect = mainPicker.querySelector('select[name="' + select.name + '"]');
              if (mainSelect && mainSelect.value !== select.value) {
                mainSelect.value = select.value;
                mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
              }
            });
          });

          /* Mostrar solo después de pasar el botón principal de compra */
          if (this.dataset.afterScroll === 'true') {
            this.style.display = 'none';
            var target =
              document.getElementById('ProductSubmitButton-' + this.section) ||
              document.querySelector('.main-product-form') ||
              document.getElementById('ProductInfo-' + this.section);
            if (target && 'IntersectionObserver' in window) {
              var observer = new IntersectionObserver(
                function (entries) {
                  entries.forEach(function (entry) {
                    var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
                    self.style.display = passed ? '' : 'none';
                  });
                },
                { threshold: 0 }
              );
              observer.observe(target);
            } else {
              this.style.display = '';
            }
          }
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <dynamic-dates> — fechas estimadas de envío (equivalente Shrine)    */
  /* ------------------------------------------------------------------ */
  if (!customElements.get('dynamic-dates')) {
    customElements.define(
      'dynamic-dates',
      class DynamicDates extends HTMLElement {
        connectedCallback() {
          var format = this.dataset.dateFormat || 'dd_mm';
          var dayLabels = (this.dataset.dayLabels || 'Mon, Tue, Wed, Thu, Fri, Sat, Sun')
            .split(',')
            .map(function (s) {
              return s.trim();
            });
          var monthLabels = (this.dataset.monthLabels || 'Jan, Feb, Mar, Apr, May, Jun, Jul, Aug, Sep, Oct, Nov, Dec')
            .split(',')
            .map(function (s) {
              return s.trim();
            });

          function formatDate(daysFromNow) {
            var d = new Date();
            d.setDate(d.getDate() + daysFromNow);
            var day = d.getDate();
            var month = monthLabels[d.getMonth()] || '';
            /* getDay(): 0=domingo; etiquetas comienzan en lunes */
            var weekday = dayLabels[(d.getDay() + 6) % 7] || '';
            var dateText = format === 'mm_dd' ? month + ' ' + day : day + ' ' + month;
            return { date: dateText, day: weekday };
          }

          this.querySelectorAll('[data-dynamic-date]').forEach(function (el) {
            var template = el.dataset.text;
            if (!template) return;
            var minDays = parseInt(el.dataset.minDays || '0', 10);
            var maxDays = parseInt(el.dataset.maxDays || '0', 10);
            var start = formatDate(minDays);
            var end = formatDate(maxDays);
            el.innerHTML = template
              .replace(/\[start_date\]/g, start.date)
              .replace(/\[end_date\]/g, end.date)
              .replace(/\[start_day\]/g, start.day)
              .replace(/\[end_day\]/g, end.day);
          });
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <internal-video> — video con controles propios (equivalente Shrine) */
  /* ------------------------------------------------------------------ */
  if (!customElements.get('internal-video')) {
    customElements.define(
      'internal-video',
      class InternalVideo extends HTMLElement {
        connectedCallback() {
          var self = this;
          this.video = this.querySelector('video');
          if (!this.video) return;

          this.video.muted = this.classList.contains('internal-video--muted');
          this.video.playsInline = true;

          var playBtn = this.querySelector('.internal-video__play');
          if (playBtn) {
            playBtn.addEventListener('click', function () {
              self.togglePlay();
            });
          }
          this.video.addEventListener('click', function () {
            self.togglePlay();
          });

          var soundBtn = this.querySelector('.internal-video__sound-btn');
          if (soundBtn) {
            soundBtn.addEventListener('click', function (event) {
              event.stopPropagation();
              self.video.muted = !self.video.muted;
              self.classList.toggle('internal-video--muted', self.video.muted);
            });
          }

          var timeline = this.querySelector('.internal-video__timeline');
          if (timeline) {
            var bar = timeline.firstElementChild || timeline;
            this.video.addEventListener('timeupdate', function () {
              if (!self.video.duration) return;
              bar.style.width = (self.video.currentTime / self.video.duration) * 100 + '%';
            });
          }

          this.video.addEventListener('play', function () {
            self.classList.add('internal-video--playing');
          });
          this.video.addEventListener('pause', function () {
            self.classList.remove('internal-video--playing');
          });

          if (this.dataset.autoplay === 'true' && 'IntersectionObserver' in window) {
            var observer = new IntersectionObserver(
              function (entries) {
                entries.forEach(function (entry) {
                  if (entry.isIntersecting) {
                    self.video.play().catch(function () {});
                  } else {
                    self.video.pause();
                  }
                });
              },
              { threshold: 0.3 }
            );
            observer.observe(this);
          }
        }

        togglePlay() {
          if (!this.video) return;
          if (this.video.paused) {
            this.video.play().catch(function () {});
          } else {
            this.video.pause();
          }
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <product-info> — contenedor de la columna de info del producto.     */
  /* Pasivo: la lógica de variantes vive en <variant-selects>. Expone    */
  /* initShareLinks() como no-op porque media-gallery.js lo invoca.      */
  /* ------------------------------------------------------------------ */
  if (!customElements.get('product-info')) {
    customElements.define(
      'product-info',
      class ProductInfo extends HTMLElement {
        initShareLinks() {
          /* no-op: el botón de compartir usa share-button.js si está presente */
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <quantity-breaks> — selector visual de "compra X" (Shrine).         */
  /* Los radios ya disparan el cambio de variante (suben a               */
  /* <variant-selects>); aquí solo gestionamos el estado visual.         */
  /* ------------------------------------------------------------------ */
  if (!customElements.get('quantity-breaks')) {
    customElements.define(
      'quantity-breaks',
      class QuantityBreaks extends HTMLElement {
        connectedCallback() {
          var self = this;
          this.addEventListener('change', function (event) {
            if (!event.target || event.target.type !== 'radio') return;
            self.querySelectorAll('label').forEach(function (label) {
              var forId = label.getAttribute('for');
              var input = forId ? self.querySelector('#' + CSS.escape(forId)) : null;
              label.classList.toggle('quantity-break--selected', !!(input && input.checked));
            });
          });
          /* estado inicial */
          var checked = this.querySelector('input[type="radio"]:checked');
          if (checked) checked.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <cart-note> — guarda la nota del pedido (Dawn, MIT)                  */
  /* ------------------------------------------------------------------ */
  if (!customElements.get('cart-note')) {
    customElements.define(
      'cart-note',
      class CartNote extends HTMLElement {
        constructor() {
          super();
          var field = this.querySelector('textarea') || this.querySelector('input');
          if (!field) return;
          field.addEventListener(
            'input',
            debounce(function (event) {
              var config = fetchConfig();
              config.body = JSON.stringify({ note: event.target.value });
              fetch((window.routes && window.routes.cart_update_url) || '/cart/update', config).catch(function (e) {
                console.error(e);
              });
            }, 300)
          );
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <secondary-variant-select> — selector de variante secundario        */
  /* (p. ej. dentro de la barra sticky). Refleja la selección al picker   */
  /* principal para reutilizar toda su lógica.                            */
  /* ------------------------------------------------------------------ */
  if (!customElements.get('secondary-variant-select')) {
    customElements.define(
      'secondary-variant-select',
      class SecondaryVariantSelect extends HTMLElement {
        connectedCallback() {
          var self = this;
          this.section = this.dataset.section || '';
          this.addEventListener('change', function (event) {
            var src = event.target;
            if (!src || (src.tagName !== 'SELECT' && src.type !== 'radio')) return;
            var picker =
              (self.section && document.getElementById('variant-selects-' + self.section)) ||
              document.querySelector('variant-selects');
            if (!picker) return;

            if (src.tagName === 'SELECT' && src.name) {
              var mainSelect = picker.querySelector('select[name="' + src.name + '"]');
              if (mainSelect && mainSelect.value !== src.value) {
                mainSelect.value = src.value;
                mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
                return;
              }
            }
            if (src.type === 'radio' && src.name) {
              var mainRadio = picker.querySelector(
                'input[type="radio"][name="' + src.name + '"][value="' + (window.CSS && CSS.escape ? CSS.escape(src.value) : src.value) + '"]'
              );
              if (mainRadio && !mainRadio.checked) {
                mainRadio.checked = true;
                mainRadio.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          });
        }
      }
    );
  }
})();
